import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';


type AlertBoxType = 'info' | 'warn' | 'error' | 'success';
type AlertBoxProps = {
    type: AlertBoxType,
    icon: IconDefinition,
    children: any,
    style?: any
}

export const AlertBox = (props: AlertBoxProps) => (
    <div className={`box-${props.type}`} style={props.style}>
        <div className="flex-center-horizontal">
            <FontAwesomeIcon icon={props.icon} size='sm' style={{ marginRight: '1em' }} />
            <p>
                {props.children}
            </p>
        </div>
    </div>
);
